import { a as t } from "../../../chunk-OA3DH5LS-40f95340.js";
const a = t("SearchAnimatedInput").parts(
  "control",
  "addon",
  "leftAddon",
  "leftIcon",
  "rightAddon",
  "clear",
  "field",
  "group"
);
export {
  a as SearchAnimatedInputAnatomy
};
//# sourceMappingURL=SearchAnimatedInput.anatomy.es.js.map
